// src/GlobalComponents/Card.js
import React from 'react';
import { Box, useColorModeValue, Heading } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const Card = ({
  title,
  children,
  bg,
  borderColor,
  textColor,
  borderRadius = 'md',
  boxShadow = 'md',
  padding = 4,
}) => {
  // Fallback to color mode-based defaults if props are not provided
  const defaultBg = useColorModeValue('rcBrand.parchment', 'rcBrand.forest'); // Apply the provided background color or fallback to color mode-based default
  const defaultBorderColor = useColorModeValue('gray.200', 'gray.700');
  const defaultTextColor = useColorModeValue('gray.700', 'white');

  // Use provided colors or fallback to color mode-based defaults
  const cardBg = bg || defaultBg; // Apply the provided background color or fallback to color mode-based default
  const cardBorderColor = borderColor || defaultBorderColor; // Apply the provided border color or fallback to color mode-based default
  const cardTextColor = textColor || defaultTextColor; // Apply the provided text color or fallback to color mode-based default

  return (
    <Box
      bg={cardBg}
      borderRadius={borderRadius}
      boxShadow={boxShadow}
      p={padding}
      border={`1px solid ${cardBorderColor}`} // Apply the border color around the card
    >
      {title && (
        <Heading size="md" color={cardTextColor} mb={4}>
          {title}
        </Heading>
      )}
      {children}
    </Box>
  );
};

Card.propTypes = {
  title: PropTypes.string, // Title of the card
  children: PropTypes.node, // Children elements inside the card
  bg: PropTypes.string, // Background color of the card
  borderColor: PropTypes.string, // Border color of the card
  textColor: PropTypes.string, // Text color of the card title
  borderRadius: PropTypes.string, // Border radius of the card
  boxShadow: PropTypes.string, // Box shadow of the card
  padding: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Padding inside the card
};

Card.defaultProps = {
  borderRadius: 'md', // Default border radius
  boxShadow: 'md', // Default box shadow
  padding: 4, // Default padding
};

export default Card;
